import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import WishlistLoader from '../../../components/WishlistLoader.js';
import { useWishlistAuthState } from '../../../hooks/use-wishlist-auth-state.js';
import AnonymousWishlistMenuItem from './AnonymousWishlistMenuItem.js';
import UserWishlistMenuItem from './UserWishlistMenuItem.js';

const WishlistMenuItemContainer = (props)=>{
    const { isAuthLoading , isUserLoggedIn  } = useWishlistAuthState();
    if (isAuthLoading) {
        return /*#__PURE__*/ React.createElement(WishlistLoader, null);
    }
    return !isAuthLoading && isUserLoggedIn ? /*#__PURE__*/ React.createElement(UserWishlistMenuItem, swcHelpers.extends({}, props)) : /*#__PURE__*/ React.createElement(AnonymousWishlistMenuItem, swcHelpers.extends({}, props));
};

export { WishlistMenuItemContainer as default };
//# sourceMappingURL=WishlistMenuItemContainer.js.map
